export const LevelColors = {
    training_plans_filter_level_1: 'lt-grey',
    training_plans_filter_level_2: 'lt-grey',
    training_plans_filter_level_3: 'lt-grey'
};

export const LevelMap = {
    training_plans_filter_level_1: 'beginner',
    training_plans_filter_level_2: 'intermediate',
    training_plans_filter_level_3: 'advanced'
};

export const PhasedTrainingPlanSubTypes = [
    'FullCentury',
    'GranFondo',
    'HalfCentury',
    'Crit',
    'TimeTrial',
    'MountainBiking'
];
